import { useKeycloak } from "@react-keycloak/web";
import type React from "react";
import { useContext, useEffect, useMemo, useState } from "react";
import TokenContext, { type TokenStateType } from "../common/TokenContext";
import Header from "./Header";
import Sidebar from "./Sidebar";
import NewTransfertModal from "./newTransferts/NewTransfertModal";

const AdminWrapper: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { keycloak, initialized } = useKeycloak();
  const [tokens, setTokens] = useState<TokenStateType>({
    idToken: "",
    accessToken: "",
    refreshToken: "",
    isLoggedIn: false,
  });
  const [isTransferModalOpen, setIsTransferModalOpen] = useState(false);

  // Mémoisation de la valeur du contexte pour éviter les re-rendus inutiles
  const contextValue = useMemo(
    () => ({
      tokens,
      setTokens,
    }),
    [tokens]
  );

  // biome-ignore lint/correctness/useExhaustiveDependencies: setTokens from useState is stable, keycloak instance is a singleton
  useEffect(() => {
    if (initialized) {
      if (keycloak.authenticated && keycloak.token && keycloak.refreshToken) {
        setTokens({
          idToken: keycloak.idToken || "",
          accessToken: keycloak.token,
          refreshToken: keycloak.refreshToken,
          isLoggedIn: true,
        });
      } else if (keycloak.authenticated === false) {
        keycloak.login();
      }
    }
  }, [
    keycloak.authenticated,
    keycloak.token,
    keycloak.refreshToken,
    initialized,
  ]);

  if (!initialized && !keycloak.authenticated) {
    return (
      <div
        style={{
          width: "100vw",
          height: "100vh", // Ensures the div takes the full height of the viewport
          display: "flex",
          justifyContent: "center", // Centers horizontally
          alignItems: "center", // Centers vertically
          textAlign: "center",
        }}
      >
        <span>Loading...</span>
      </div>
    );
  }

  return (
    <TokenContext.Provider value={contextValue}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          overflow: "hidden",
        }}
      >
        <NewTransfertModal
          open={isTransferModalOpen}
          onClose={() => setIsTransferModalOpen(false)}
        />
        <div>
          <Header />
        </div>
        <div
          style={{
            display: "flex",
            // height: "calc(100vh - 72px)",
            width: "100%",
            overflow: "hidden",
            padding: "20px",
            gap: "20px",
          }}
        >
          <Sidebar setOpenTransfertModal={() => setIsTransferModalOpen(true)} />
          <div style={{width: '100%'}}>{children}</div>
        </div>
      </div>
    </TokenContext.Provider>
  );
};

export default AdminWrapper;

// eslint-disable-next-line react-refresh/only-export-components
export const useAuth = () => {
  const context = useContext(TokenContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
